import { render, staticRenderFns } from "./FigmaShapeLayer.vue?vue&type=template&id=0c764401"
import script from "./FigmaShapeLayer.vue?vue&type=script&lang=js"
export * from "./FigmaShapeLayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c764401')) {
      api.createRecord('0c764401', component.options)
    } else {
      api.reload('0c764401', component.options)
    }
    module.hot.accept("./FigmaShapeLayer.vue?vue&type=template&id=0c764401", function () {
      api.rerender('0c764401', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/figma-layers/layers/FigmaShapeLayer.vue"
export default component.exports